"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgGiftFilled(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("defs", null,
            React.createElement("style", null, '.gift_filled_svg__cls-1{display:none}')),
        React.createElement("path", { className: "gift_filled_svg__cls-1", d: "M0 0h32v32H0z", id: "gift_filled_svg__transparent_box" }),
        React.createElement("g", { id: "gift_filled_svg__FILLED" },
            React.createElement("path", { className: "gift_filled_svg__cls-1", d: "M13.65 4.65A1.78 1.78 0 0012.54 4a1.5 1.5 0 00-1 .56c-.64.67-.85 1.28.09 2.25A5.27 5.27 0 0014.78 8a5.67 5.67 0 00-1.13-3.35zM20.24 4.56a1.5 1.5 0 00-1-.56 1.81 1.81 0 00-1.11.65A5.74 5.74 0 0017 8a5.22 5.22 0 003.13-1.15c.97-1.01.76-1.62.11-2.29z" }),
            React.createElement("path", { d: "M17 27v1h9V15h-9v12zM15 15H6v13h9V15zM15 9V8h2v5h11V8h-6.24a3.26 3.26 0 00-.08-4.83A3.35 3.35 0 0019.26 2a3.57 3.57 0 00-2.55 1.26 4.88 4.88 0 00-.81 1.15 4.6 4.6 0 00-.81-1.15c-1.59-1.64-3.44-1.67-5-.09A3.26 3.26 0 0010 8H4v5h11zm3.15-4.35A1.81 1.81 0 0119.26 4a1.5 1.5 0 011 .56c.65.67.86 1.28-.09 2.25A5.22 5.22 0 0117 8a5.74 5.74 0 011.15-3.35zm-6.59-.09a1.5 1.5 0 011-.56 1.78 1.78 0 011.11.65A5.67 5.67 0 0114.78 8a5.27 5.27 0 01-3.13-1.15c-.94-1.01-.73-1.62-.09-2.29z" }))));
}
exports.default = SvgGiftFilled;
//# sourceMappingURL=GiftFilled.js.map